import { render, staticRenderFns } from "./SearchSale.vue?vue&type=template&id=71618ce8&scoped=true"
import script from "./SearchSale.vue?vue&type=script&lang=js"
export * from "./SearchSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71618ce8",
  null
  
)

export default component.exports